module.exports = __webpack_public_path__ + "static/media/c62.749cfb50.png";